import React from 'react';
import SystemOptions from './accountSystemOptions.jsx';
import SystemSummary from './accountSystemSummary.jsx';
import Loader from '../../../../components/loader.jsx';
import {FormattedMessage} from 'react-intl';
import CustomerApi from '../../../../../api/customer.jsx';
import ReportSummaryErrorHandler from '../../components/reportSummaryErrorHandler';
import {makeCancelable} from 'helpers/cancelablePromise';

class SystemList extends React.Component {
  state = {
    data: [],
    filters: [],
    loaded: true,
    showNoDataMessage: false,
    error: false,
  };

  componentWillUnmount() {
    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }
  }

  updateReportData = (from, to, store, systemType, groundLevel, sanitazer, accountStatus) => {

    let filters = {
      dateTo: to,
      dateFrom: from,
      store: store,
      systemType: systemType,
      groundLevel: groundLevel,
      sanitazer: sanitazer,
      accountStatus: accountStatus,
    };

    this.setState({
      loaded: false,
      error: false,
    });

    if (this.fetching && !this.fetching.isFinished) {
      this.fetching.cancel();
    }else{
      this.setState({
        data: [],
      });
    }

    (this.fetching = makeCancelable(CustomerApi.getAccountSystemListSummary(from, to, store, systemType, groundLevel, sanitazer, accountStatus)))
    .then(res => {
      if(res && res.TotalAccounts > 0) {
        this.setState({
          data: res,
          filters: filters,
          loaded: true,
          showNoDataMessage: false,
          error: false,
        });
      } else {
        this.setState({showNoDataMessage: true, error: false});
      }
      this.setState({loaded: true, filters: filters});
    }).catch(e => {
      console.log(e);
      if (e && e.canceled) {return;}
      this.setState({loaded: true,showNoDataMessage: true});
    });
  };

  render() {
    return <div className="report-container">
      <span>
        <FormattedMessage id="reports.account.system.description"/>
      </span>
      <SystemOptions updateReportData={this.updateReportData}
                     dealer={this.props.dealer}
                     branches={this.props.branches}/>
      <Loader loaded={this.state.loaded}>
        <ReportSummaryErrorHandler error={this.state.error}>
          <SystemSummary filters={this.state.filters}
                       data={this.state.data}
                       showNoDataMessage={this.state.showNoDataMessage}
                       TruBlueActive={this.props.TruBlueActive}/>
        </ReportSummaryErrorHandler>
      </Loader>
    </div>;
  }
}

export default SystemList;
